import React, { Component } from 'react'
import './Footer.css'
import facebookLogo from '../../images/icons/facebook.svg'
import twitterLogo from '../../images/icons/twitter.svg'
import instagramLogo from '../../images/icons/instagram.svg'
import sopiaLogo from '../../images/icons/logo.png'

export default class Footer extends Component {
  render() {
    return (
      <div className='footer-container'>
        <img className="footer-logo" src={sopiaLogo} alt="logo"></img>
        <ul className='footer-menu'>
            <li>Customer Service</li>
            <li>Terms of Use</li>
            <li>Data Protection</li>
        </ul>

       <ul className='footer-social'>
            <li><img src={facebookLogo} alt={'facebook'} fill="#fff"></img> Facebook</li>
            <li><img src={twitterLogo} alt={'X'}></img>X</li>
            <li><img src={instagramLogo} alt={'instagram'}></img>Instagram</li>
        </ul>

        <div className='footer-subscribe'>
            <p>Subscribe to Our Newsletter</p>
            <p className='footer-email'>Email Address<span className='email-ok'>OK</span></p>
        </div>
        <ul className='footer-contact'>
            <li>Helsinki, Finland</li>
            <li>+358405888436</li>
            <li>info@sopia.io</li>
        </ul>
      </div>
    )
  }
}
